export default __webpack_public_path__ + "media/images/features/local_delivery/episode7/LP_03-bfb45d10eb695c6f78882c90777f2bcb.jpg";